import React from 'react';
import { BookmarkForm } from '../Common/Bookmarks/BookmarkForm';

import { uuidV4 } from '@readcloud/common';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
} from '@readcloud/component-library';
import {
  applicationSelectors,
  authSelectors,
  bookmarksActions,
  jobsActions,
  readerSelectors,
  useAppDispatch,
} from '@readcloud/state';
import { ObjectId } from 'bson';
import { useSelector } from 'react-redux';
import { DocumentWithExtrasContext } from '../../context/DocumentWithExtras';
import { getPageLabelByString } from '../../utils/utils';
import { SelectionState } from '../CustomSelection/SelectionStream';

export const ConnectedBookmarkForm = (props: {
  onSuccess: () => void;
  onCancel: () => void;
  open: boolean;
  selectionState: SelectionState;
}) => {
  const readerData = useSelector(readerSelectors.getReaderData);
  const appData = useSelector(applicationSelectors.getApplcationState);
  const user = useSelector(authSelectors.getUser);
  const dispatch = useAppDispatch();

  const [initialSelection, setInitialSelection] =
    React.useState<SelectionState>(undefined);

  React.useEffect(() => {
    setInitialSelection(props.selectionState);
  }, [props.selectionState?.selectedText]);

  const { location } = React.useContext(DocumentWithExtrasContext);

  return (
    <Modal isOpen={props.open} toggle={props.onCancel}>
      <ModalHeader>
        <div className="d-flex justify-content-between w-100">
          <ModalTitle>Create a Bookmark</ModalTitle>
          <span>Page: {parseInt(initialSelection?.location) || location}</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <BookmarkForm
          onCancel={props.onCancel}
          onSuccess={(values) => {
            if (user && readerData.bookId && readerData.cloudId) {
              dispatch(
                bookmarksActions.asyncActions.addBookmark({
                  authorId: user.id,
                  bookId: readerData.bookId,
                  cloudIds: [readerData.cloudId],
                  created: new Date().toISOString(),
                  updated: new Date().toISOString(),
                  clientCreated: new Date().toISOString(),
                  clientUpdated: new Date().toISOString(),
                  deleted: false,
                  id: new ObjectId().valueOf().toString(),
                  location: initialSelection?.location || location,
                  text: values.text,
                  version: '2',
                })
              ).then(() => {
                dispatch(
                  jobsActions.addJob({
                    id: uuidV4(),
                    description: `Bookmark added on page ${
                      parseInt(initialSelection?.location) || location
                    }!`,
                  })
                );
              });
            }

            props.onSuccess();
          }}
          initialValues={{
            text: initialSelection?.selectedText || '',
            pageNumber: initialSelection?.location || location,
            pageLabel: getPageLabelByString(
              initialSelection?.location || location
            ),
          }}
        />
      </ModalBody>
    </Modal>
  );
};
